
import React, { useState } from 'react';
import { InlineLoading } from 'carbon-components-react';
import { CaretDown32 } from '@carbon/icons-react';

import * as DashboardConstants from './DashboardConstants'
require("./_dashboard-summary-new.scss");

const DashboardSummary = (props) => {
    const summary = props.summary;
    return (
        <div className="dashboard-summary-new">
            <div className="summary-wrapper">
                <div className="title">
                    {DashboardConstants.Summary}
                </div>
                <div className="dashboard-title">
                    {props.title}
                </div>
            </div>
            <div className="tile-container">
                {props.loading ?
                    <div className="tile loading-container">
                        <InlineLoading
                            description={DashboardConstants.Loading}
                        />
                    </div>
                    :
                    props.summary && props.summary.length ?
                        summary.map((type, index) => (
                            <div className="tiles" key={index}>
                                <div className="tile-title carbon-display-Semibold-16">
                                    {type.title}
                                </div>
                                <div style={{ display: 'flex' }}>
                                    <div className="tile-value carbon-display-Light-48">
                                        {typeof type.value === 'number' ? Math.round(type.value || 0) : type.value}
                                    </div>
                                    {(type.showPercent) && (type.showPercent) && (type.value !== 0) && (type.value !== '-') ?
                                        <div className="percent-wrapper">
                                            %
                                        </div> : null}
                                    {type.target ? <div className="statusIndicator">
                                        <CaretDown32
                                            style={{ height: '20px', width: '20px' }}
                                        />
                                        {type.target}
                                    </div> : ''}
                                </div>
                            </div>
                        ))
                        :
                        <div style={{ margin: '50px' }}>
                            {DashboardConstants.NoDataAvailable}
                        </div>
                }
            </div>
        </div >
    );
};

export default DashboardSummary;
